import * as React from "react";
import { Col } from "react-bootstrap";
import { slugify } from "transliteration";
import {
  breadcrumb,
  breadcrumbItem,
  counter,
  active,
  postactive,
  crumbLabel,
  customBreadcrumContainer,
  breadCrumItemContainer,
} from "./CustomBreadCrumb.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { updateAllRooms } from "../../../redux/slices/Checkout/checkout";
import { navigate } from "gatsby";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

export const BreadCrumb: React.FC<any> = (props) => {
  let { step } = props;
  const { crumbs, location } = props;
  const { isMobileOnly } = useMobileDetectContext();
  const dispatch = useDispatch();
  const checkoutStore = useSelector((state: any) => state.checkout);
  const allRooms = { ...checkoutStore.Rooms };
  const crumbItems = crumbs.map((crumb: any, idx: number) => {
    let itemClass = "";
    let ariaCurrent = "";
    const index = idx + 2; //* Removed search and hotel page from breadcrumb. To make less code changes we have to start index from 2, and it will use the existing code
    if (!step) {
      step = crumb.page == location.pathname ? index : null;
    }
    if (index == step) {
      itemClass = active;
      ariaCurrent = "page";
    } else if (step && index > step) {
      itemClass = postactive;
    }
    const handleStepNavigation = (stepValue: string) => {
      if (index < step) {
        if (stepValue === "select-room") {
          const obj: any = {};
          Object.keys(allRooms).forEach((key: any) => {
            obj[key] = {
              ...allRooms[key],
              rate: null,
              room: null,
              services: null,
            };
          });
          dispatch(updateAllRooms(obj));
          navigate("/checkout");
        }
        if (stepValue === "guest-details" && props.handleGoToGuestDetailsStep) {
          props.handleGoToGuestDetailsStep();
        }
      }
    };
    return (
      <BreadCrumbItem
        key={`customCrumb-${index}`}
        index={idx}
        itemClass={itemClass}
        crumb={crumb}
        ariaCurrent={ariaCurrent}
        handleStepNavigation={handleStepNavigation}
        crumbId={crumb.id}
      />
    );
  });
  return (
    step && (
      <nav aria-label="breadcrumb">
        <ol className={breadcrumb}>
          <div
            className={`container-sm ${customBreadcrumContainer} ${
              isMobileOnly ? "justify-content-between" : ""
            }`}
          >
            {crumbItems}
          </div>
        </ol>
      </nav>
    )
  );
};

const BreadCrumbItem: React.FC<any> = (props) => {
  const {
    itemClass,
    crumb,
    index,
    ariaCurrent,
    handleStepNavigation,
    crumbId,
  } = props;
  return (
    <Col lg={2} sm={{ span: 3 }} className={`${breadCrumItemContainer}`}>
      <li
        id={slugify(crumb.text)}
        className={`${itemClass} ${breadcrumbItem}`}
        aria-current={ariaCurrent}
        onClick={() => handleStepNavigation(crumbId, itemClass)}
      >
        <span className={counter}>{index + 1}</span>
        <span className={crumbLabel}>{crumb.text}</span>
      </li>
    </Col>
  );
};
